import { render, staticRenderFns } from "./Onboarding.vue?vue&type=template&id=64d33e79&scoped=true&lang=pug&"
import script from "./Onboarding.vue?vue&type=script&lang=js&"
export * from "./Onboarding.vue?vue&type=script&lang=js&"
import style0 from "./Onboarding.scss?vue&type=style&index=0&id=64d33e79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d33e79",
  null
  
)

export default component.exports